const Style = {
  base: 'absolute left-1/2 top-1/2 w-6 h-6 -translate-y-1/2 -translate-x-1/2',
  orbit: 'animate-loading',
};

export default Style;
